import { ClientIdType } from '~/enums/ClientIdType';

import { checkIsSuperAdmin } from './checkIsSuperAdmin';
import { and } from './utils/and';
import { testHasClientId } from './utils/testHasClientId';

export const checkIsInternalSuperAdmin = and([
  checkIsSuperAdmin,
  testHasClientId(ClientIdType.General),
]);
